module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/responsible/responsible-view/responsible-view.component.css
// module id = ./src/app/components/responsible/responsible-view/responsible-view.component.css
// module chunks = main